// src/config.ts

// Asegúrate de que tu .env contiene:
// REACT_APP_INSTALACIONES_URL=https://n8n.sisnetel.com/webhook/instalaciones
// REACT_APP_CEDULA_FRONTAL_URL=https://n8n.sisnetel.com/webhook/sisnetel/api/v1/cedulafrontal
// REACT_APP_CEDULA_POSTERIOR_URL=https://n8n.sisnetel.com/webhook/sisnetel/api/v1/cedulaposterior

const requiredEnvVars = [
  'REACT_APP_INSTALACIONES_URL',
  'REACT_APP_CEDULA_FRONTAL_URL',
  'REACT_APP_CEDULA_POSTERIOR_URL',
];

requiredEnvVars.forEach(envVar => {
  if (!process.env[envVar]) {
    throw new Error(`Falta definir ${envVar} en .env`);
  }
});

export const API = {
  instalaciones: process.env.REACT_APP_INSTALACIONES_URL!,
  cedulaFrontal: process.env.REACT_APP_CEDULA_FRONTAL_URL!,
  cedulaPosterior: process.env.REACT_APP_CEDULA_POSTERIOR_URL!,

  /**
   * Subida de la imagen de la cédula a Drive, separada del escaneo.
   *
   * Son OPCIONALES a propósito: si faltan (por ejemplo, si se olvidan de
   * añadirlas en EasyPanel), la app NO se cae. Simplemente vuelve al
   * comportamiento anterior, esperando que el webhook de escaneo devuelva
   * él mismo el enlace de Drive.
   */
  cedulaFrontalDrive: process.env.REACT_APP_CEDULA_FRONTAL_DRIVE_URL || '',
  cedulaPosteriorDrive: process.env.REACT_APP_CEDULA_POSTERIOR_DRIVE_URL || '',
};